import { generatePath, Navigate, useNavigate } from 'react-router-dom';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { Box } from '@mui/material';
import { ParkingPortalMenuListItem } from '../mobile/layout/ParkingPortalMenuListItem.tsx';
import { ParkingPortalLayoutWithHeader } from '../mobile/layout/ParkingPortalLayoutWithHeader.tsx';
import { useRecodeEntryWithoutExitOutlet } from './CloudConnectorRecodeEntryWithoutExitConditionsOutlet.tsx';

export function CloudConnectorRecodeEntryWithoutExit() {
    const { recodeConditions, offstreetTransactionSearchQuery } =
        useRecodeEntryWithoutExitOutlet();
    const navigate = useNavigate();
    return (
        <ParkingPortalLayoutWithHeader
            title={
                <Localized
                    de="Rabattbedingungen"
                    fr="Conditions de rabais"
                    it="Condizioni ribasso"
                    en="Discount conditions"
                />
            }
            backTo={`..${offstreetTransactionSearchQuery}`}
            scrollable
        >
            <Box>
                {recodeConditions.length == 1 ? (
                    <Navigate
                        to={generatePath('recodeCondition/:recodeConditionId', {
                            recodeConditionId:
                                recodeConditions[0].recodeConditionId,
                        })}
                        replace={true}
                    />
                ) : (
                    recodeConditions.map(recodeCondition => (
                        <ParkingPortalMenuListItem
                            key={recodeCondition.recodeConditionId}
                            onClick={() =>
                                navigate(
                                    `${generatePath(
                                        'recodeCondition/:recodeConditionId',
                                        {
                                            recodeConditionId:
                                                recodeCondition.recodeConditionId,
                                        },
                                    )}${offstreetTransactionSearchQuery}`,
                                )
                            }
                            text={
                                <Localized
                                    {...recodeCondition.recodeConditionDescription}
                                />
                            }
                        />
                    ))
                )}
            </Box>
        </ParkingPortalLayoutWithHeader>
    );
}
